import { channelInfo, gameInfo, propInfo, channelTodayInfo, allXienChannelInfo } from './api';

const fetchChannelInfo = (context) => {
	return new Promise((resolve, reject) => {
		let fromStorage = JSON.parse(localStorage.getItem("channel"));
		if(fromStorage && Object.keys(fromStorage).length != 0){
			context.commit('GAME_INFO', {"channels": fromStorage});
	  		resolve(fromStorage);
		}else{
			channelInfo()
		    	.then((response) => {
		    		let data = {};
		    		$.each(response.data.data, (idx, e) => { data[e.id] = e; });
		    		localStorage.setItem("channel", JSON.stringify(data));
			  		context.commit('GAME_INFO', {"channels": data});
			  		resolve(data);
				})
				.catch((error) => {
			  		console.error(error);
			  		reject(error);
				});
		}
    });
};

const fetchGameInfo = (context) => {
	return new Promise((resolve, reject) => {
		let fromStorage = JSON.parse(localStorage.getItem("game"));
		if(fromStorage && Object.keys(fromStorage).length != 0){
			context.commit('GAME_INFO', {"games": fromStorage});
	  		resolve(fromStorage);
		}else{
			gameInfo()
		    	.then((response) => {
		    		let data = {};
		    		$.each(response.data.data, (idx, e) => { data[e.id] = e.alias; });
		    		localStorage.setItem("game", JSON.stringify(data));
			  		context.commit('GAME_INFO', {"games": data});
			  		resolve(data);
				})
				.catch((error) => {
			  		console.error(error);
			  		reject(error);
				});
		}
    });
};

const fetchPropInfo = (context) => {
	return new Promise((resolve, reject) => {
		let fromStorage = JSON.parse(localStorage.getItem("prop"));
		if(fromStorage && Object.keys(fromStorage).length != 0){
			context.commit('GAME_INFO', {"props": fromStorage});
	  		resolve(fromStorage);
		}else{
			propInfo()
		    	.then((response) => {
		    		let data = {};
		    		$.each(response.data.data, (idx, e) => { data[e.id] = e.alias; });
		    		localStorage.setItem("prop", JSON.stringify(data));
			  		context.commit('GAME_INFO', {"props": data});
			  		resolve(data);
				})
				.catch((error) => {
			  		console.error(error);
			  		reject(error);
				});
		}
    });
};

const fetchChannelTodayInfo = (context) => {
	return new Promise((resolve, reject) => {
		channelTodayInfo()
	    	.then((response) => {
	    		let data = {};
	    		$.each(response.data.data, (idx, e) => { 
	    			if(!data[e.game_id]) data[e.game_id] = [];
	    			data[e.game_id].push(e);
	    		});

		  		context.commit('GAME_INFO', {"channelToday": data});
		  		resolve(data);
			})
			.catch((error) => {
		  		console.error(error);
		  		reject(error);
			});
    });
};

const fetchXienChannelInfo = (context) => {
	return new Promise((resolve, reject) => {
		let fromStorage = JSON.parse(localStorage.getItem("xienChannels"));
		if(fromStorage && Object.keys(fromStorage).length != 0){
			context.commit('GAME_INFO', {"xienChannels": fromStorage});
	  		resolve(fromStorage);
		}else{
			allXienChannelInfo()
		    	.then((response) => {
		    		localStorage.setItem("xienChannels", JSON.stringify(response.data.data));
			  		context.commit('GAME_INFO', {"xienChannels": response.data.data});
			  		resolve(response.data.data);
				})
				.catch((error) => {
			  		console.error(error);
			  		reject(error);
				});
		}
    });
}

export default {
	fetchChannelInfo,
	fetchGameInfo,
	fetchPropInfo,
	fetchChannelTodayInfo,
	fetchXienChannelInfo
};